import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as spaceUse from '../../space-use'

export const RESOURCE = {
  payload: {
    description:
      'A broad category of how space is used. This could include options such as "Lab", "Office", or "Exam", for example.',
    dimension: spaceUse.RESOURCE.payload,
    level: 0,
    name: 'Room Group',
    partialId: PartialId.Standard.create('group'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
